var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","open-delay":"1000","disabled":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticStyle:{"width":"100%","height":"16em"},attrs:{"id":"draw-gauge"}},'div',attrs,false),on))]}}])},[_c('span',[_vm._v("Score")])])}
var staticRenderFns = []

export { render, staticRenderFns }